<template>
  <Buttons
    v-if="configurationGroup.type == 'BUTTON'"
    :configurationGroup="configurationGroup"
    :selected="configurations[configurationGroup.valueId]"
    :configurator-id="configuratorId"
    :is-stacked-configurator="isStackedConfigurator"
    :show-divider="showDivider"
    @input="loadConfigurationAndClose($event)"
  >
  </Buttons>
  <Circles
    v-else-if="configurationGroup.type == 'CIRCLE'"
    :configurationGroup="configurationGroup"
    :configurator-id="configuratorId"
    :is-stacked-configurator="isStackedConfigurator"
    :show-divider="showDivider"
    @input="loadConfigurationAndClose($event)"
  >
  </Circles>
  <Tiles
    v-else-if="configurationGroup.type == 'TILE'"
    :configurationGroup="configurationGroup"
    :selected="configurations[configurationGroup.valueId]"
    :configurator-id="configuratorId"
    :is-stacked-configurator="isStackedConfigurator"
    :show-divider="showDivider"
    @input="loadConfigurationAndClose($event)"
  >
  </Tiles>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Circles from './Circles.vue';
import Buttons from './Buttons.vue';
import Tiles from './Tiles.vue';

export default {
  name: 'Rule',
  components: {
    Buttons,
    Circles,
    Tiles,
  },
  props: {
    configurationGroup: Object,
    type: String,
    configuratorId: Number,
    isStackedConfigurator: {
      type: Boolean,
      default: false,
    },
    showDivider: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('product', [
      'configurations', //
    ]),
  },
  methods: {
    ...mapMutations('product', [
      'updateCurrentOpenConfigurator', //
    ]),
    ...mapActions('product', [
      'loadConfigurations', //
    ]),
    async loadConfigurationAndClose(event) {
      this.updateCurrentOpenConfigurator(null);
      await this.loadConfigurations(event);
      this.$emit('input', event);
    },
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';
</style>
